import { 
  BrowserRouter as Router,
  Routes,
  Route
} from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';
import theme from './common/Theme/Theme'; // The path to your theme.js file

import Layout from './components/Layout/Layout'
import Home from './pages/Home/Home';
import Login from './pages/Login/Login';
import SignUp from './pages/SignUp/SignUp';
import UserProfile from './pages/Profile/Profile';
import Scatter from './pages/Scatter/Scatter';
import BarChart from './pages/Barchart/Barchart';
import StrategiesPage from './pages/Strategies/Strategies';
import WorkInProgress from './common/WorkInProgress/WorkInProgress';
import ScatterPBI from './pages/scatterPowerBI/scatterPBI';
import MyStrategiesPage from './pages/Strategies/MyStrategiesPage';


function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          {/* Add other routes for different pages */}
          <Route path="/" element={<Home />} exact/>
          <Route path="/login" element={<Login/>} />
          <Route path="/sign-up" element={<SignUp/>} />
          <Route path="/UserProfile" element={<UserProfile/>} />
          <Route path="/Scatter" element={<Scatter/>} />
          <Route path="/Barchart" element={<BarChart/>} />
          <Route path="/WorkInProgress" element={<WorkInProgress/>} />
          <Route path="/Strategies" element={<StrategiesPage/>} />
          <Route path="/ScatterPBI" element={<ScatterPBI/>} />
          <Route path="/Strategies/MyStrategiesPage" element={<MyStrategiesPage/>} />
        </Routes>
      </Layout>
      
    </Router>
    
  );
}

export default App;